export const colors: Record<string, string> = {
  white: 'hsl(0, 0%, 100%)',
  veryDarkCyan: 'hsl(183, 100%, 15%)',
  darkGrayishCyan: 'hsl(186, 14%, 43%)',
  darkerGrayishCyan: 'hsl(184, 14%, 56%)',
  lightGrayishCyan: 'hsl(185, 41%, 84%)',
  lighterGrayishCyan: 'hsl(189, 41%, 97%)',
  coralGreen: '#9fe8df',
  danger: '#dc3545',
};
